// "Captured today" / "Yesterday" / "12 days ago": when a person was captured in LeadIQ.
export function capturedLabel(iso: string | null | undefined): string {
  if (!iso) return ''
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return ''
  const days = Math.floor((Date.now() - t) / 86_400_000)
  if (days <= 0) return 'Captured today'
  if (days === 1) return 'Yesterday'
  return `${days} days ago`
}
